import Theme from '@amzn/meridian/theme'
import { queryClient } from '@amzn/woot-services-vendor-portal-core/lib/react-query'
import { useAppStore } from '@amzn/woot-services-vendor-portal-shared-ui/stores/app-store'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import Head from 'next/head'
import { FC, lazy, PropsWithChildren, Suspense, useEffect } from 'react'

import rebrandTheme from '../utils/rebrand-theme.json'

const ReactQueryDevtoolsProduction = lazy(() =>
  // Instructions for making devtools accessible in production:
  // https://tanstack.com/query/latest/docs/framework/react/devtools
  import('@tanstack/react-query-devtools/build/modern/production.js').then(
    (d: { ReactQueryDevtools: FC }) => ({
      default: d.ReactQueryDevtools,
    }),
  ),
)

export const AppProvider = ({ children }: PropsWithChildren) => {
  const { app, onToggleReactQueryDevtools } = useAppStore()

  useEffect(() => {
    // @ts-expect-error: TODO - update global type def
    window.toggleDevtools = () => onToggleReactQueryDevtools()
  }, [onToggleReactQueryDevtools])

  return (
    <Theme palette={rebrandTheme} mode={app.darkMode}>
      <QueryClientProvider client={queryClient}>
        <Head>TODO</Head>
        {children}
        <ReactQueryDevtools initialIsOpen={false} />
        {app.reactQueryDevTools === 'show' && (
          <Suspense fallback={null}>
            <ReactQueryDevtoolsProduction />
          </Suspense>
        )}
      </QueryClientProvider>
    </Theme>
  )
}
